import {
  ChangeDetectorRef,
  Component,
  NgModule,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router, Routes } from '@angular/router';
import { GearsApiService } from 'src/app/services/gearsapi.service';
import { CommonModule, Location } from '@angular/common';
import { ModalService } from 'src/app/modules/modalservice.service';
import { SitesService } from 'src/app/services/sites.service';
import { environment } from 'src/environments/environment';

import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { SliderComponent, SliderModule } from '../../../slider/slider.component';
import { ImglistComponent } from '../../../imglist/imglist.component';
import { EnquireComponent } from '../../../enquire/enquire.component';
import { TaskServiceService } from 'src/app/services/task-service.service';
import { DynamicsliderModule } from 'src/app/components/dynamicslider/dynamicslider.component';
import { FormsModule } from '@angular/forms';

@Pipe({
  name: 'safe',
})
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(url: any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
declare var Spin: any;
@Component({
  selector: 'app-detailsAlter',
  templateUrl: './detailsAlter.component.html',
  styleUrls: ['./detailsAlter.component.less'],
})
export class DetailsAlterComponent implements OnInit {
  @ViewChild('spin', { static: false }) spin: any;
  hideColourName: boolean = false;
  VehicleSeries: any;
  vehicleSeriesKeyFeatures: any;
  ExteriorImages: any;
  InteriorImages: any;
  currentIndex: number = 0;
  vehicleFeatures: any = [];
  tabsHeadings: any = [];
  tabsList: any = [];
  EnquireTitle: any;
  constructor(
    private changeDetector: ChangeDetectorRef,
    private siteService: SitesService,
    private apiservice: GearsApiService,
    private route: ActivatedRoute,
    private location: Location,
    public modalService: ModalService,
    private title: Title,
    private taskservice: TaskServiceService,
    private router: Router
  ) {}
  Model: any = [];
  Specs: any[] = [];
  Images: any = [];
  modelId: string = '0';
  type: string = '0';
  modelname: string = '0';
  Dealerships: any;
  Dealer: any;
  imgaeindex: number = 0;
  imgloaded: boolean = false;
  specsOpen = false;
  galltype = 0;
  Accessories: any = [];
  currentSite: any;
  Stock: any = [];

  href(ref: string) {
    window.location.href = ref;
  }
  fav(id: string, type: string) {
    var favs: any[] = JSON.parse(localStorage.getItem('fav') || '[]');
    if (!favs.includes(type + '-' + id)) {
      favs.push(type + '-' + id);
    } else {
      const index = favs.indexOf(type + '-' + id);
      if (index > -1) {
        favs.splice(index, 1);
      }
    }
    localStorage.setItem('fav', JSON.stringify(favs));
  }
  isfav(v: any, type: string) {
    return JSON.parse(localStorage.getItem('fav') || '[]').includes(
      type + '-' + (v.VehicleStockID_PK || v.VehicleModelID_PK || v.VehicleID)
    );
  }
  openBrochure(url:any){
    window.open(url, "_blank")?.focus();
  }
  stockenquire(vehicle: any) {
    var data = {
      ID:
        vehicle.SpecialID_PK ||
        vehicle.VehicleStockID_PK ||
        vehicle.VehicleModelID_PK ||
        vehicle.VehicleID,
      Name: vehicle.WebFriendlyName ? (vehicle.ModelYear + ' ' + vehicle.WebFriendlyName) 
          : vehicle.type == 'NewModel' ? vehicle.ModelDescription || vehicle.Caption 
          : vehicle.ModelDescription ? (vehicle.ModelYear + ' ' + vehicle.ModelDescription) : vehicle.Caption,
      Dealer: vehicle.GroupSpecial ? null : vehicle.DealershipID_FK,
      Price:
        vehicle.NewVehiclePrice || vehicle.Price || vehicle.RetailPriceIncl,
      Type:
        'newstock',
      Source: 1,
    };
    this.modalService.open('enquire', data);
  }
  stockfinance(price: number) {
    this.modalService.open('finance', price);
  }
  urlsan(url: any) {
    return url
      .replaceAll('+', '')
      .replaceAll('/', '')
      .replaceAll('\\', '')
      .replaceAll('(', '')
      .replaceAll(')', '')
      .replaceAll(' ', '_');
  }

  loadScripts() {
    this.changeDetector.detectChanges();
    const dynamicScripts = [
      'https://static.instavid360.com/p/0.7.latest/spin360.lite.js',
    ];
    for (let i = 0; i < dynamicScripts.length; i++) {
      const node = document.createElement('script');
      node.src = dynamicScripts[i];
      node.setAttribute('data-portal', 'master');
      node.setAttribute('data-spin', this.Model.InstavidSpinID);
      this.spin.nativeElement.appendChild(node);
    }
  }

  ngOnInit(): void {
    this.modelId = this.route.snapshot.paramMap.get('id')!;
    this.type = this.route.snapshot.paramMap.get('type')!;
    this.modelname = this.route.snapshot.paramMap.get('name')!;
    if (this.type == 'new') {
      this.apiservice
        .getSingle('VehicleModels', this.modelId, {})
        .then((x: any) => {
          if (x.body.Active) {
            this.Model = x.body;
            this.apiservice
              .get('VehicleModelSpecs', {
                VehicleModelID_FK: this.Model.VehicleModelID_PK,
              })
              .then((specs: any) => {
                this.Specs = specs.body;
              });
             this.apiservice.getSingle('VehicleSeries', this.Model.VehicleSeriesID_FK, {}).then((x:any) => {
                this.VehicleSeries = x.body;
                this.apiservice.get('VehicleSeriesKeyFeatures', {
                  Active:1
                  ,Deleted:0
                  ,LinkedVehicleSpecCategory: 'Key Features Descriptions'
                  ,OrderBy: ''
                  ,PageNumber:1
                  ,PageSize:9999
                  ,VehicleSeriesID_FK:this.VehicleSeries.VehicleSeriesID_PK
                }).then((features:any) => {
                  this.vehicleSeriesKeyFeatures = features.body.sort((a:any, b:any) => {
                    try{
                      if (parseInt((a.VehicleSpecCategory).split(' ')[0]) < parseInt((b.VehicleSpecCategory).split(' ')[0])) {
                        return -1;
                      }
                      if (parseInt((a.VehicleSpecCategory).split(' ')[0]) > parseInt((b.VehicleSpecCategory).split(' ')[0])) {
                        return 1;
                      }
                      return 0;
                    }
                    catch(e){
                      if (+(a.VehicleSpecCategory).split(' ')[0] < (b.VehicleSpecCategory).split(' ')[0]) {
                        return -1;
                      }
                      if (+(a.VehicleSpecCategory).split(' ')[0] > (b.VehicleSpecCategory).split(' ')[0]) {
                        return 1;
                      }
                      return 0;
                    }
                  });;
                  this.vehicleSeriesKeyFeatures?.forEach((element:any) => {
                    if ((element.VehicleSpecCategory?.toLowerCase())?.includes('feature')) {
                        this.vehicleFeatures.push(element);
                    }
                    if ((element.VehicleSpecCategory?.toLowerCase())?.includes('tabs')) {
                      this.tabsHeadings.push(element);
                      
                    }
                    if ((element.VehicleSpecCategory?.toLowerCase())?.includes('listing')) {
                      this.tabsList.push(element);
                    }
                  });
                });
             });
            this.siteService.get().then((site: any) => {
              this.currentSite = site;
              this.title.setTitle("New " + this.Model.ModelDescription + " | " + this.currentSite?.container?.Name);

              this.EnquireTitle = this.currentSite.layoutGlobal?.some((global: any) => global.PageLayoutTypeName.toUpperCase() == 'ENQUIRETITLE');

            });
            this.Images = this.Model.Images;
            this.InteriorImages = this.Model.Images?.filter((x:any) => x.includes('interior'));
            this.ExteriorImages = this.Model.Images?.filter((x:any) => (!x.includes('interior')&& !x.includes('main')));

            this.gtag('n');
          } else {
            window.location.href = '404';
          }
        });
    }
  }

  sortAcc() {
    if (this.Model.VehicleStockAccessoriesList) {
      var i = 0;
      this.Accessories =
        //var vehicleAccessories =
        this.Model.VehicleStockAccessoriesList.split(',');
      /*vehicleAccessories.sort();
      while (vehicleAccessories.length > 0) {
        this.Accessories.push([
          vehicleAccessories.shift(),
          vehicleAccessories.shift(),
        ]);
        i++;
      }*/
    }
  }

  gtag(type: any) {
    let gaScript = document.createElement('script');
    gaScript.innerText =
      "gtag('event','view_item', {'value': " +
      (this.Model.RetailPriceIncl || this.Model.NewVehiclePrice) +
      ",'items': [{'id': " +
      type +
      (this.Model.CACStockID || this.Model.CACID) +
      ",'google_business_vertical': 'retail'}]});";

    document.head.appendChild(gaScript);
  }
  num(inp: string) {
    var it = inp;
    return it.split(' ').join(',');
  }
  enquire() {
    var data = {
      ID:
        this.Model.SpecialID_PK ||
        this.Model.VehicleStockID_PK ||
        this.Model.VehicleModelID_PK ||
        this.Model.VehicleID,
        Name: this.EnquireTitle ? this.Model.VehicleSeries : this.Model.WebFriendlyName ? (this.Model.ModelYear + ' ' + this.Model.WebFriendlyName) : this.Model.ModelDescription || this.Model.Caption,
      Dealer: this.Model.GroupSpecial ? null : this.Model.DealershipID_FK,
      Price:
        this.Model.NewVehiclePrice ||
        this.Model.Price ||
        this.Model.RetailPriceIncl,
      Type:
        this.Model.VehicleStockType ? 
        this.Model.VehicleStockType == 'New'? 'newstock':this.Model.VehicleStockType == 'Pre-Owned' || this.Model.VehicleStockType == 'Demo' ? 
                'used' 
                : this.Model.VehicleModelID_PK ?  'new' : this.Model.VehicleStockType.toLowerCase()
          : this.type == 'special' ? 'specials' : this.type,
        Source: 1,
    };
    this.modalService.open('enquire', data);
  }


  back(): void {
    if (!!(this.router.getCurrentNavigation()?.previousNavigation)){
      this.location.back();
    }else{
      window.location.href = '/buy';
    }
  }

  spec(name: string) {
    var find = this.Specs.find((x: any) => x.VehicleSpecsDefaultName == name);
    if (find) {
      return find.Value;
    } else {
      return '-';
    }
  }

  currentHeading(index :any) {
    this.currentIndex = index;
  }

  imgadd(url: string) {
    if (!url.includes('http')) {
      return environment.storageurl + url;
    }
    else {
      return url;
    }

  }
}

const routes: Routes = [
  {
    path: '',
    component: DetailsAlterComponent,
    data: { Module: 'Buy', Title: 'Buy' },
  },
];

@NgModule({
  declarations: [
    DetailsAlterComponent,
    SafePipe,
  ],
  imports: [
    CommonModule,
    SliderModule,
    EnquireComponent,
    DynamicsliderModule,
    FormsModule
  ],
  exports: [
    DetailsAlterComponent
  ]
})
export class DetailsAlterModule {}
